import React from "react";


// Page Components:
import UserLoginView from '../../../Fragments/UserLogin/UserLoginView';

import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import Box  from "@mui/material/Box";




// import FilterView from "../../../Fragments/Filter/FilterView";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CustomDialog({dialogSttng,handleDlgClose}) {


    return(

      <Dialog
          fullScreen={dialogSttng.bFullScreen}
          open={dialogSttng.bDialogOpen}
          slots={{ transition: Transition }}
          onClose={handleDlgClose}>
        <Box>
          <Box
            onClick={handleDlgClose}
            sx={{padding:'0.3rem', width:'3rem', borderStyle:'groove', textAlign:'center', fontWeight:'bold', borderRadius:'0.3rem'}}>X</Box>
          {( () => {
            switch (dialogSttng.sDialogParam) { //sParam onFilterClose={onFilterClose}
            case 'usrLgn':
                return <UserLoginView ></UserLoginView>
            case 'objdet':
                // return <ObjDetailView currObjId={currObjId}></ObjDetailView>
            break;
            default:
                return null
            }
          }) ()}
        </Box>

      </Dialog>
    )

}

export default CustomDialog;